import Button from '@/common/components/Button'
import CreateForwardingDirectiveEntryFormStepHeader from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepHeader'
import EstablishmentChoiceList from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/EstablishmentChoiceEntryFormStep/EstablishmentChoiceList'
import { establishmentChoiceEntryOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant'
import { MaintenanceForwardingsEstablishmentChoiceEntryStepOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { EstablishmentChoiceEntryValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { useCreateForwardingsFormStore } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/stores/createForwardingsFormStore'
import { useFormContext, useWatch } from 'react-hook-form'
import { useParams } from 'react-router-dom'

const EstablishmentChoiceEntryManualEntryPending = () => {
  const { directiveEntryType } = useParams();

  const { setSelectedEstablishments, increaseStep } = useCreateForwardingsFormStore()

  const { control, setValue } = useFormContext<EstablishmentChoiceEntryValidationSchema>()

  const { establishment_choice_entry_attributes: watchEstablishmentChoiceEntryAttributes } = useWatch({
    control,
  })

  const watchEstablishmentId = watchEstablishmentChoiceEntryAttributes?.establishment_id

  const manualEntryOption =
    establishmentChoiceEntryOptions[MaintenanceForwardingsEstablishmentChoiceEntryStepOptions.ManualEntry]

  return (
    <div className="flex flex-col gap-4">
      <CreateForwardingDirectiveEntryFormStepHeader
        goBackAction={() => {
          setValue('establishment_choice_entry_type', undefined!)
          setValue('establishment_choice_entry_attributes', undefined!)
        }}
        title={manualEntryOption.title}
        description={manualEntryOption.description(directiveEntryType)}
      />

      <EstablishmentChoiceList
        selectedEstablishmentsIds={watchEstablishmentId ? [watchEstablishmentId] : []}
        onSelectEstablishment={(establishment) => {
          if (establishment.establishment_id === watchEstablishmentId) {
            setValue('establishment_choice_entry_attributes.establishment_id', undefined!)
            setSelectedEstablishments([])

            return
          }

          setValue('establishment_choice_entry_attributes.establishment_id', establishment.establishment_id)
          setSelectedEstablishments([establishment])
        }}
      />

      <div className="flex items-center justify-between">
        <p className="text-sm">
          {watchEstablishmentId ? '1 Estabelecimento selecionado' : 'Nenhum estabelecimento selecionado'}
        </p>

        <div className="flex items-center gap-2">
          <Button
            variant="error"
            onClick={() => {
              setValue('establishment_choice_entry_type', undefined!)
              setValue('establishment_choice_entry_attributes', undefined!)
            }}
          >
            Cancelar
          </Button>

          <Button disabled={!watchEstablishmentId} onClick={increaseStep}>
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EstablishmentChoiceEntryManualEntryPending
